(ns frontend.ui.component.text.style
  (:require
   [frontend.ui.style.theme.core :refer [color font-weight text-size]]))

(defn text
  [props]
  (let [font-weight-id (:font-weight props)
        text-size-id (:text-size props :small)
        color-id (:color props)
        css-props (dissoc props :font-weight :text-size :color)]
    (merge
     {:font-size   (text-size text-size-id :size)
      :line-height (text-size text-size-id :height)}
     (when color-id
       {:color (color [:palette color-id])})
     (when font-weight-id
       {:font-weight (font-weight font-weight-id)})

     css-props)))
